import { InjectionToken } from '@angular/core';

export const STREAMAMG_CONFIG = new InjectionToken<StreamAMGSettings>('STREAMAMG_CONFIG');
export class StreamAMGSettings {
  ApiKey: string;
}
